import * as React from "react";
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
  desc?: string;
  descId?: string;
}
const SvgDurationIcon = ({
  title,
  titleId,
  desc,
  descId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    data-slot="icon"
    width={24}
    height={24}
    aria-labelledby={titleId}
    aria-describedby={descId}
    {...props}
  >
    {desc ? <desc id={descId}>{desc}</desc> : null}
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M12 9.75v3.6l2.3529 1.35M12 5.7c-4.4183 0-8 3.425-8 7.65S7.5817 21 12 21s8-3.425 8-7.65-3.5817-7.65-8-7.65m0 0V3m-1.8824 0h3.7648m5.9566 3.2328-1.4117-1.35.7059.675m-14.9722.675 1.4117-1.35-.7059.675"
    />
  </svg>
);
export default SvgDurationIcon;
